// Wait for the element to be present in the DOM
function waitForElement(selector, callback, timeout = 5000, interval = 100) {
  const startTime = Date.now();
  function check() {
    const element = document.querySelector(selector);
    if (element) {
      try {
        callback(element);
      } catch (err) {
        console.error(`waitForElement: Error in callback for "${selector}":`, err);
      }
    } else if (Date.now() - startTime < timeout) {
      setTimeout(check, interval);
    } else {
      console.warn(`waitForElement: Element "${selector}" not found within ${timeout}ms`);
    }
  }
  check();
}
